import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar";
import "./AdminLayout.css";

export default function AdminLayout({ children }) {
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const adminName = localStorage.getItem("admin_name") || "Admin";

  const handleLogoutConfirm = () => {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_name");
    localStorage.removeItem("admin_role");
    navigate("/login", { replace: true });
  };

  return (
    <div className="admin-layout">
      {/* Top Header */}
      <header className="admin-layout__header">
        <div className="admin-layout__brand">
          <button
            className="admin-layout__hamburger"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="22" height="22">
              {mobileMenuOpen ? (
                <path d="M18 6L6 18M6 6l12 12" />
              ) : (
                <path d="M3 12h18M3 6h18M3 18h18" />
              )}
            </svg>
          </button>
          <img src="/logo.png" alt="Resh Photography" className="admin-layout__logo-img" />
          <span className="admin-layout__logo">Resh Photography</span>
          <span className="admin-layout__tag">Admin</span>
        </div>
        <div className="admin-layout__actions">
          <span className="admin-layout__admin-name">{adminName}</span>
          <button
            className="admin-layout__logout"
            onClick={() => setShowLogoutModal(true)}
          >
            Logout
          </button>
        </div>
      </header>

      {/* Body: Sidebar + Page Content */}
      <div className="admin-layout__body">
        <Sidebar isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
        {mobileMenuOpen && (
          <div
            className="sidebar__backdrop"
            onClick={() => setMobileMenuOpen(false)}
          />
        )}
        <main className="admin-layout__content">{children}</main>
      </div>

      {/* Logout Confirmation Modal */}
      {showLogoutModal && (
        <div
          className="logout-modal__overlay"
          role="dialog"
          aria-modal="true"
          aria-labelledby="logout-title"
        >
          <div className="logout-modal">
            <h3 className="logout-modal__title" id="logout-title">
              Confirm Logout
            </h3>
            <p className="logout-modal__msg">
              Are you sure you want to log out?
            </p>
            <div className="logout-modal__actions">
              <button
                className="logout-modal__btn logout-modal__btn--cancel"
                onClick={() => setShowLogoutModal(false)}
              >
                Cancel
              </button>
              <button
                className="logout-modal__btn logout-modal__btn--confirm"
                onClick={handleLogoutConfirm}
              >
                Yes, Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
